enum PosterHeight {
  Small = '15.2rem',
  Default = '25.3rem',
  Large = '55rem',
}

export default PosterHeight;
